import naja from "naja";
import onDomReady from "./onDomReady";
/** EVENTS */


onDomReady(() => {
	$(window)
		.on('scroll resize', function () {
			list_page_map_scroll();
		});
	window.LazyLoad.update();
});

/** MAP & FILTERS POSITIONING */
let el = $('.list-page-header'),
	lpm = $('.list-page-map'),
	lpf = $('.list-page-filters'),
	lpc = $('.list-page-content'),
	lpcr = $('.list-page-content-results');

function list_page_map_scroll() {
	const st = $(window).scrollTop(),
		header_height = $(window).width() >= 1560 ? 99 : 73;
	const filter_pos_top = header_height + el.outerHeight() - 2,
		// map_pos_top = $('.list-page-map-position-helper').offset().top,
		height = $(window).height() - header_height - list_page_header_max_height();

	lpc.css('min-height', height);

	let pos_bottom = st + $(window).height() - lpc.offset().top - lpc.outerHeight();

	if (pos_bottom < 0)
		pos_bottom = 0;

	if ($(window).width() > 1024) {
		if (st <= (lpc.offset().top - header_height - list_page_header_max_height()) || pos_bottom !== 0) {
			if (st > lpc.offset().top - header_height - list_page_header_max_height())
				lpm.css('top', $('.list-page-content-col-right').outerHeight() - height);
			else
				lpm.css('top', 0);

			lpm
				.css({
					'position': 'relative',
					'left': 0,
					'right': 0,
					'width': '100%',
					'height': height + 'px'
				});
		} else {
			lpm
				.css({
					'position': 'fixed',
					'top': 'auto',
					'left': '66.666%',
					'right': 0,
					'bottom': 0,
					'width': '33.333%',
					'-webkit-transform': 'translateY(0)',
					'-moz-transform': 'translateY(0)',
					'-ms-transform': 'translateY(0)',
					'-o-transform': 'translateY(0)',
					'transform': 'translateY(0)'
				});
		}
		lpm
			.css('height', height + 'px')
			.css('z-index', 1);
	} else {
		lpm.removeAttr('style');
	}

	if ($(window).width() > 440 && $(window).height() > 500) {
		lpf
			.css('top', filter_pos_top - pos_bottom + 'px')
			.css('height', height + 'px')
			.css('max-width', '440px')
			.css('z-index', 2);
	} else {
		lpf
			.css('top', 0)
			.css('bottom', 0)
			.css('height', '100%')
			.css('max-width', 'inherit')
			.css('width', '100%')
			.css('z-index', 110);
	}
}

list_page_map_scroll();

/** FILTERS */
$('.list-page-content-filter-icon,.list-page-filters-header .close').on('click', function () {
	$('.list-page-filters').toggleClass('shown');

	const html = $('html');
	if (html.hasClass('no-scroll'))
		html.removeClass('no-scroll');
	else if ($(window).width() <= 440 || $(window).height() <= 500)
		html.addClass('no-scroll');
});

let filter_timeout,
	items_offset = 0,
	load_more_button = $('.list-page-content-load-more'),
	map_cards,
	map_markers;

function run_filter_request(clear) {
	let items_limit = 12;
	if ($(window).width() <= 1024)
		items_limit = 9;
	else if ($(window).width() <= 768)
		items_limit = 6;
	else if ($(window).width() <= 580)
		items_limit = 3;

	toggleSpinner();

	const form = document.getElementById('list-page-filters');
	const formData = new FormData(form);
	formData.append('items_limit', items_limit);
	formData.append('items_offset', items_offset);
	formData.append('sort_by', $('input[name="sort_by"]').val());
	formData.append('sort_direction', $('input[name="sort_direction"]').val());

	naja.makeRequest('POST', '?do=filter', formData, {history: false}).then((payload) => {
		if (clear) {
			lpcr.find('.col').remove();
			map_cards = [];
			items_offset = 0;
		}

		for (const i in payload.map_cards)
			if (Object.prototype.hasOwnProperty.call(payload.map_cards, i)) {
				map_cards.push(payload.map_cards[i]);
			}

		$('.list-page-content-filters-count').text(payload.number_of_results_string);
		lpcr = $('.list-page-content-results');
		if (clear) {
			lpcr.find('.col-12.loading').remove();
			lpcr.find('.row').html(payload.items_html); // Přepíše obsah při změně filtru
		} else {
			lpcr.find('.row').append(payload.items_html); // Přidá nové položky při stránkování
		}
		$('input[name="sort_by"]').val(payload.sort_by);
		$('.sorting-button').removeClass('active');
		$('.sorting-button[data-value="' + payload.sort_by + '"]')
			.addClass('active')
			.find('.direction')
			.removeClass('direction-asc')
			.removeClass('direction-desc')
			.addClass('direction-' + payload.sort_direction);
		$('input[name="sort_direction"]').val(payload.sort_direction);

		if (payload.number_of_results === lpcr.find('.card').length)
			load_more_button.fadeOut(250);
		else
			load_more_button.fadeIn(250);

		list_page_map_scroll();
		refreshMap();
	}).catch((error) => {
		console.error(error);
	}).finally(() => {
		toggleSpinner();
		window.LazyLoad.update();
	});
}

window.run_filter_timeout = function (time) {
	clearTimeout(filter_timeout);

	if (time <= 0) {
		items_offset = 0;
		run_filter_request(true);
		return true;
	}

	if (!time)
		time = 750;

	filter_timeout = setTimeout(function () {
		items_offset = 0;
		run_filter_request(true);
	}, time);
};

load_more_button.find('button').on('click', function () {
	items_offset = lpcr.find('.card').length;
	run_filter_request();
});

$('input[type="checkbox"]').on('change', function () {
	window.run_filter_timeout();
});

$('.sorting-button').on('click', function () {
	$('.sorting-button').removeClass('active');
	const button = $(this);
	const sort_by = $('input[name="sort_by"]');
	const sort_direction = $('input[name="sort_direction"]');
	button.addClass('active');

	if (sort_by.val() !== button.attr('data-value')) {
		sort_by.val(button.attr('data-value'));
		sort_direction.val('asc');
		button.find('.direction').removeClass('direction-desc').addClass('direction-asc');
	} else if (sort_by.val() === button.attr('data-value')) {
		if (button.find('.direction').hasClass('direction-asc')) {
			button.find('.direction')
				.removeClass('direction-asc')
				.addClass('direction-desc');
			sort_direction.val('desc');
		} else {
			button.find('.direction')
				.removeClass('direction-desc')
				.addClass('direction-asc');
			sort_direction.val('asc');
		}
	}
	window.run_filter_timeout(0);
});

$('select#sorting').on('change', function () {
	const sort_by = $('input[name="sort_by"]');
	const sort_direction = $('input[name="sort_direction"]');
	const v = $(this).find('option:selected').val(),
		sb = v.split(';')[0],
		sd = v.split(';')[1];

	$('.sorting-button').find('.direction').removeClass('direction-desc').removeClass('direction-asc');
	$('.sorting-button[data-value="' + sb + '"]').find('.direction').addClass('direction-' + sd);
	sort_by.val(sb);
	sort_direction.val(sd);
	window.run_filter_timeout(0);
});

/** MAP */
let google_api_key = 'AIzaSyBx1Me0CRNz_TvhMJUk3FOFZJ0TIKrQU1s', // Frontend api key
	map,
	infoWindow;

$('.list-page-content-map-icon,.list-page-map-header .close').on('click', function () {
	$('.list-page-map').toggleClass('shown');

	const html = $('html');
	if (html.hasClass('no-scroll'))
		html.removeClass('no-scroll');
	else if ($(window).width() <= 440 || $(window).height() <= 500)
		html.addClass('no-scroll');
});

const gapi_script = document.createElement('script');
gapi_script.src = 'https://maps.googleapis.com/maps/api/js?key=' + google_api_key + '&callback=initMap&libraries=marker&loading=async';
document.head.appendChild(gapi_script);

window.initMap = function () {
	map = new window.google.maps.Map(document.getElementById('google-map'), {
		center: {lat: 48.974579, lng: 14.474214},
		zoom: 14,
		mapId: 'google-map'
	});
	infoWindow = new window.google.maps.InfoWindow({
		maxWidth: 240
	});
};

function refreshMap() {
	for (const im in map_markers)
		if (Object.prototype.hasOwnProperty.call(map_markers, im))
			map_markers[im].setMap(null);

	map_markers = [];

	for (const ic in map_cards)
		if (Object.prototype.hasOwnProperty.call(map_cards, ic)) {
			let contentString = '<a href="' + map_cards[ic].url + '" class="list-page-map-card">' +
				'<img src="' + map_cards[ic].photo + '" class="list-page-map-card-photo">' +
				'<p class="list-page-map-card-title">' + map_cards[ic].title + '</p>';

			if (map_cards[ic].address)
				contentString += '<p class="list-page-map-card-address">' + map_cards[ic].address + '</p>';

			contentString += '</a>';

			const marker = new window.google.maps.marker.AdvancedMarkerElement({
				position: {lat: map_cards[ic].gps_lat, lng: map_cards[ic].gps_lng},
				map: map,
			});

			marker.customId = map_cards[ic].id;

			window.google.maps.event.addListener(marker, 'gmp-click', function () {
				infoWindow.close();
				infoWindow.setContent(buildContent(map_cards[ic]));
				infoWindow.open(map, this);
			});

			map_markers.push(marker);
		}

	const bounds = new window.google.maps.LatLngBounds();
	for (let i = 0; i < map_markers.length; i++) {
		bounds.extend(map_markers[i].position);
	}

	map.fitBounds(bounds);
}

function buildContent(map_card) {
	const content = document.createElement('a');
	content.href = map_card.url;
	content.className = 'list-page-map-card';
	content.innerHTML = '<img src="' + map_card.photo + '" class="list-page-map-card-photo">' +
		'<p class="list-page-map-card-title">' + map_card.title + '</p>';

	if (map_card.address)
		content.innerHTML += '<p class="list-page-map-card-address">' + map_card.address + '</p>';

	return content;
}

window.showOnMap = function (id) {
	if (map) {
		for (const ic in map_markers)
			if (Object.prototype.hasOwnProperty.call(map_markers, ic))
				if (map_markers[ic].customId === id) {
					infoWindow.setContent(buildContent(map_cards[ic]));
					infoWindow.open(map, map_markers[ic]);
					if ($(window).width() < 1024)
						$('.list-page-content-map-icon').trigger('click');
					map.setZoom(16);
				}
	}
}

function showOnMap(id) {
	for (const ic in map_markers)
		if (Object.prototype.hasOwnProperty.call(map_markers, ic))
			if (map_markers[ic].id === id) {
				infoWindow.setContent(map_markers[ic].info);
				infoWindow.open(map, map_markers[ic]);
				if ($(window).width() < 1024)
					$('.list-page-content-map-icon').trigger('click');
				map.setZoom(16);
			}
}

/** SPINNER */
function toggleSpinner() {
	$('.list-page-spinner-wrapper').toggleClass('shown');
}

function list_page_header_max_height() {
	if ($(window).width() <= 580) return 60;
	if ($(window).width() <= 1024) return 80;
	if ($(window).width() <= 1560) return 100;
	return 130;
}
